@if (!isLoading && pageInfo.breadcrumb) {
  <nav aria-label="breadcrumb" class="breadcrumb-nav">
    <ol>
      @if (pageInfo?.['pagesAbove']?.length > 0) {
        @for (page of pageInfo['pagesAbove']; track $index) {
          <li>
            @if (page.clickable === false || !page.url) {
              <span class="inactive-link">
                {{ page.title }}{{ page.identification ?? '' }}
              </span>
            } @else {
              <a [routerLink]="page.url" [queryParams]="page.queryParams">
                {{ page.title }}{{ page.identification ?? '' }}
              </a>
            }
          </li>
          <li class="separator" aria-hidden="true">></li>
        }

        <li class="active" aria-current="page">
          {{ pageInfo?.['title'] }}{{ pageInfo?.['identification'] ?? '' }}
        </li>
      } @else {
        <li class="active" aria-current="page">
          {{ pageInfo?.title }}
        </li>
      }
    </ol>
  </nav>
}
